import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GameStyled from './Game.styled';
import PageWrap, { PageTransition } from '../Page/Page.styled';
import PathBlockContainer from '../../molecules/PathBlockContainer/PathBlockContainer';
import GameStats from '../../molecules/GameStats/GameStats';
import GameSelector from '../../organisms/GameSelector/GameSelector';
import StartButton from '../../atoms/StartButton/StartButton';
import CurrentLevel from '../../atoms/CurrentLevel/CurrentLevel';
import MobileLandscapeNote from '../../atoms/MobileLandscapeNote/MobileLandscapeNote';

const mapStateToProps = state => ({
  viewing: state.viewing,
  started: state.game.started,
  roundWin: state.game.roundWin,
  timeOut: state.game.timeOut,
  showWarning: state.showWarning,
  currentLevel: state.saved.level,
});

export const Game = ({ viewing, started, roundWin, timeOut, currentLevel }) => (
  <PageWrap>
    <GameSelector viewing={viewing === 'selector'} />
    <CSSTransition
      in={viewing === 'game'}
      appear
      timeout={600}
      classNames="game-wrap"
    >
      <PageTransition
        className="game-wrap"
        aria-hidden={viewing === 'game' ? 'false' : 'true'}
      >
        <GameStyled id="game-wrap" viewing={viewing === 'game'}>
          <CurrentLevel currentLevel={currentLevel} />
          <GameStats />
          <StartButton show={!started && !timeOut && !roundWin} />
          <PathBlockContainer />
        </GameStyled>
      </PageTransition>
    </CSSTransition>
    <MobileLandscapeNote />
  </PageWrap>
);

export default connect(mapStateToProps)(Game);

Game.propTypes = {
  viewing: PropTypes.string.isRequired,
  started: PropTypes.bool.isRequired,
  timeOut: PropTypes.bool.isRequired,
  roundWin: PropTypes.bool.isRequired,
  currentLevel: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/pages/Game/Game.js